import { createSlice } from '@reduxjs/toolkit';
import fetchWallet, {
  chargeWallet,
  fetchDiscountsWallet,
  getAllTransactions,
  getCreatersWallet,
  getTransactionLogs,
  updateTransactionStatus,
} from './action';

export const walletSlice = createSlice({
  name: 'wallet',
  initialState: {
    wallet: {},
    discountWallets: [],
    creatersWallet: [],
    transactions: [],
    logs: [],
    isLogsLoading: true,
    isLoading: true,
    error: null,
  },
  reducers: {
    initWallet: (state) => {
      state.wallet = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWallet.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchWallet.fulfilled, (state, { payload }) => {
        state.wallet = payload;
        state.isLoading = false;
      })
      .addCase(fetchWallet.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload;
      })
      .addCase(fetchDiscountsWallet.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchDiscountsWallet.fulfilled, (state, { payload }) => {
        state.discountWallets = payload;
        state.isLoading = false;
      })
      .addCase(fetchDiscountsWallet.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload;
      })
      .addCase(chargeWallet.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(chargeWallet.fulfilled, (state, { payload }) => {
        state.wallet = [payload];
        state.isLoading = false;
        state.error = null;
      })
      .addCase(chargeWallet.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload;
      })
      .addCase(getCreatersWallet.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getCreatersWallet.fulfilled, (state, { payload }) => {
        state.creatersWallet = payload;
        state.isLoading = false;
        state.error = null;
      })
      .addCase(getCreatersWallet.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload;
      })
      .addCase(getAllTransactions.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getAllTransactions.fulfilled, (state, { payload }) => {
        state.transactions = payload;
        state.isLoading = false;
        state.error = null;
      })
      .addCase(getAllTransactions.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload;
      })
      .addCase(getTransactionLogs.pending, (state) => {
        state.isLogsLoading = true;
        state.error = null;
      })
      .addCase(getTransactionLogs.fulfilled, (state, { payload }) => {
        state.logs = payload;
        state.isLogsLoading = false;
        state.error = null;
      })
      .addCase(getTransactionLogs.rejected, (state, { payload }) => {
        state.isLogsLoading = false;
        state.error = payload;
      })
      .addCase(updateTransactionStatus.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateTransactionStatus.fulfilled, (state, { payload }) => {
        state.transactions = state.transactions.map((trans) =>
          trans._id === payload._id ? { ...trans, ...payload } : trans
        );
        state.isLoading = false;
        state.error = null;
      })
      .addCase(updateTransactionStatus.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload;
      });
  },
});

export const { initWallet } = walletSlice.actions;

export default walletSlice.reducer;
